import React, { useEffect, useState } from 'react';
import { getMethod } from '../services/apiService';

const Terms = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const welcome = async () => {
      try {
        const response = await getMethod('welcome');
        if (response && response.status && Array.isArray(response.data)) {
          setData(response.data[0]);
        } else {
          console.error('Failed to fetch welcome data:', response.error || response);
        }
      } catch (error) {
        console.error('Error fetching welcome data:', error);
      }
    };

    welcome();
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <div className="privacypolicy-list">
        <div dangerouslySetInnerHTML={{ __html: data?.termsandconditions || '' }} />
      </div>
    </div>
  );
};

export default Terms;
